import React, { useState, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { Typography, Grid, Button, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import SubQuestionDetails from "./SubQuestionDetails";
import {
  AppConfig,
  LEGAL_RESULT_SUB_QID,
  roles,
  LEGAL_OPINION_CATEGORY_ID,
  LEGAL_COMMENT_QUESTION_ID,
  LEGAL_APPROVAL_QUESTION_ID,
  LEGAL_CHOOSE_FILE_SUBQUESTION_ID
} from "@configs/admin-config";
import { getAccessToken, getIdToken, checkIfRoleExists } from "@utils/oauth";
import CommentInputs from "./CommentInputs";

import parse from "html-react-parser";

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: 2,
    color: "white",
  },
  descriptionParent: {
    display: "flex",
  },

  descriptionIndex: {
    flexBasis: "4%",
    "@media(max-width: 900px)": {
      flexBasis: "5%",
    },
    "@media(max-width: 600px)": {
      flexBasis: "10%",
    },
    "@media(max-width: 400px)": {
      flexBasis: "15%",
    },
  },
  descriptionDetails: {
    flexBasis: "96%",
    textAlign: "justify",
    "@media(max-width: 900px)": {
      flexBasis: "95%",
    },
    "@media(max-width: 600px)": {
      flexBasis: "90%",
    },
    "@media(max-width: 400p6x)": {
      flexBasis: "85%",
    },
  },
  buttonGrid: {
    marginBottom: 5,
    paddingLeft: "4.3%",
    "@media(max-width: 900px)": {
      paddingLeft: "5%",
    },
    "@media(max-width: 600px)": {
      paddingLeft: "10%",
    },
    "@media(max-width: 400px)": {
      paddingLeft: "15%",
    },
  },
  saveButton: {
    textTransform: "none",
    margin: "8px 6px",
  },
  editButton: {
    left: 15,
    textTransform: "none",
  },
  uploadButton: {
    textTransform: "none",
    marginTop: 0,
    marginLeft: 0,
    marginRight: 10,
  },
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const QuestionDetails = (props) => {
  const { classes } = useStyles();
  const question = props.question;
  const subQuestions = props.subQuestions;
  const files = props.files;

  const [backdropOpen, setbackDrop] = useState(false);
  const [fieldDisabled, setFieldDisabled] = useState(false);
  const [successSnack, setSuccess] = useState(false);
  const [errorSnack, setErrorSnack] = useState(false);
  const [answers, setAnswers] = useState([]);
  const [callbackAnswer, setCallbackAnswer] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [isError, setError] = useState(false);
  const [isTrue, setIsTrue] = useState(undefined);
  const [resetFileState, setResetFileState] = useState(false);

  useEffect(() => {
    // setAnswers(props.answers)
  }, [props.answers]);

  const callback = (subQuestionId, booleanAnswer, descriptionAnswer, uploadFiles, isValid) => {
    if (subQuestionId === LEGAL_RESULT_SUB_QID) {
      setIsTrue(booleanAnswer);
    }
    setAnswers(answers.filter((item) => item.subQuestionId !== subQuestionId));
    setIsValid(isValid);

    if (isValid) {
      setError(false);
      setAnswers((prev) => [
        ...prev,
        {
          subQuestionId: subQuestionId,
          questionId: question.questionId,
          booleanAnswer: Boolean(booleanAnswer),
          descriptionAnswer: descriptionAnswer,
          uploadFiles: uploadFiles,
          companyId: props.companyId,
        },
      ]);

      setCallbackAnswer([
        {
          subQuestionId: subQuestionId,
          questionId: question.questionId,
          booleanAnswer: Boolean(booleanAnswer),
          descriptionAnswer: descriptionAnswer,
          uploadFiles: uploadFiles,
          companyId: props.companyId,
        },
      ]);
    }
  };

  const saveData = async () => {
    if (isValid) {
      setbackDrop(true);
      setFieldDisabled(true);
      const requestURL = AppConfig.baseUrl + AppConfig.legalApproval;
      const data = {
        answers: answers,
        token: getIdToken(),
        legalResult: isTrue === true ? "approved" : isTrue === false ? "rejected" : null,
      };

      try {
        let response = await fetch(requestURL, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + getAccessToken(),
          },
          body: JSON.stringify(data),
        });
        let body = await response.json();
        if (response.status === 200) {
          setSuccess(true);
          setIsValid(false);
          props.formRender();
        } else {
          console.error(body.message);
          setErrorSnack(true);
        }
        setbackDrop(false);
        return null;
      } catch (error) {
        console.error(error);
        return error;
      }
    } else {
      setError(true);
    }
  };

  useEffect(() => {
  if (resetFileState) {
    setResetFileState(false);
  }
}, [resetFileState]);

  const editField = () => {
    setFieldDisabled(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccess(false);
    setErrorSnack(false);
  };

  const disableCall = (isDisable, answer) => {
    const hasCurrentQuestionAnswer = props.answers.some((ans) => ans.questionId === question.questionId);

    if (answer.length > 0 || hasCurrentQuestionAnswer) {
      setFieldDisabled(true);
    } else {
      setFieldDisabled(isDisable);
    }
  };

  const attachFilesSubQuestion = subQuestions.find(
    (subq) => subq.subQuestionId === LEGAL_CHOOSE_FILE_SUBQUESTION_ID
  );

  return (
    <React.Fragment>
      <Backdrop open={backdropOpen} className={classes.backdrop}>
        <CircularProgress color="secondary" />
      </Backdrop>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={successSnack} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Success!
        </Alert>
      </Snackbar>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={errorSnack} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          Failed!
        </Alert>
      </Snackbar>

      <React.Fragment>
        <Grid item xs={12}>
          <div className={classes.descriptionParent}>
            <Typography className={classes.descriptionIndex}></Typography>
            <Typography variant="body2" className={classes.descriptionDetails}>
              {parse(question.questionHeading)}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.verticalcenter}>
          <div className={classes.descriptionParent}>
            <Typography className={classes.descriptionIndex}>
              {props.categoryId}.{question.sortIndex}
            </Typography>
            <Typography className={classes.descriptionDetails}>{parse(question.questionDescription)}</Typography>
          </div>
        </Grid>
        {subQuestions.length > 0 &&
        subQuestions.map((subQuestion) => {
          return subQuestion.questionId === question.questionId ? (
            <React.Fragment key={subQuestion.subQuestionId}>
              <SubQuestionDetails
                key={subQuestion.subQuestionId}
                categoryId={props.categoryId}
                question={question}
                subQuestion={subQuestion}
                files={files}
                parentCallback={callback}
                formCompleted={props.formCompleted}
                isSubmitted={props.isSubmitted}
                isDrafted={props.isDrafted}
                disabled={props.disabled}
                disableCall={disableCall}
                isError={isError}
                fieldDisabled={fieldDisabled}
                answer={
                  props.answers && props.answers.filter((answer) => answer.subQuestionId === subQuestion.subQuestionId)
                }
                callbackAnswer={callbackAnswer}
                companyId={props.companyId}
                resetFileState={resetFileState}
                email={props.email}
              />
            </React.Fragment>
          ) : null;
        })}

        {(question.questionId === LEGAL_COMMENT_QUESTION_ID) && (
            <Grid item xs={12}>
              <CommentInputs
                questionId={question.questionId}
                companyId={props.companyId}
                comments={props.comments}
                formRender={props.formRender}
                subQuestion={attachFilesSubQuestion}
                email={props.email}
                files={files}
              />
            </Grid>
          )}
        {props.categoryId === LEGAL_OPINION_CATEGORY_ID &&
          checkIfRoleExists(roles.legalApprover) &&
          question.questionId === LEGAL_APPROVAL_QUESTION_ID && (
          <div className={classes.buttonGrid} container>
            <Button
              className={classes.saveButton}
              variant="contained"
              color="secondary"
              disabled={fieldDisabled || !isValid}
              size="small"
              onClick={saveData}
            >
              Save
            </Button>
            <Button
              className={classes.editButton}
              variant="outlined"
              color="primary"
              disabled={!fieldDisabled}
              size="small"
              onClick={editField}
            >
              Edit
            </Button>
          </div>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};

export default QuestionDetails;
